import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

const lazyWithRetry = (importFn: () => Promise<{ default: React.ComponentType }>) =>
  lazy(() =>
    importFn().catch(() => {
      window.location.reload();
      return importFn();
    })
  );

export const ROLE_MANAGEMENT_ROUTES: TApplicationRoute[] = [
  {
    id: 'role-management',
    path: '/admin/role-management',
    component: lazyWithRetry(() => import('./pages/role-management-page')),
    layout: 'default',
    permissions: { scopes: [] },
    menu: {
      title: 'pages.admin.roleManagement.title',
    },
  },
];
